import { Grid, Button, FormGroup, FormControlLabel } from "@mui/material";
import { styled, alpha } from "@mui/material/styles";

export const FieldsContainer = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  gap: "10px",

  "& .MuiBox-root": {
    display: "flex",
    gap: "10px",

    "&>div": {
      width: "100%",
    },
  },

  "& .MuiFormGroup-root": {
    display: "flex",
    flexDirection: "row",
  },
});

export const AddEditButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== "effect" && prop !== "asLink",
})<{ effect: "add" | "edit"; asLink: boolean }>(({ effect, asLink, theme }) => ({
  ...(effect === "add" && {
    color: theme.palette.primary.contrastText,
    borderColor: theme.palette.primary.contrastText,

    "&:hover": {
      borderColor: alpha(theme.palette.primary.contrastText, 0.5),
    },
  }),
  ...(asLink && {
    color: theme.palette.primary.main,
  }),
  ...(!asLink && {
    minWidth: "35px",
    height: "35px",
    padding: 0,
    fontSize: "1em",
    lineHeight: "1.5em",
    textTransform: "none",
  }),
}));

export const PeriodContainer = styled(Grid)(({ theme }) => ({
  display: "flex",
  gap: "10px",

  ...theme.typography.body2,
  '& [role="separator"]': {
    margin: theme.spacing(0, 2),
  },

  "& .MuiFormControlLabel-root": {
    width: "100%",
  },

  "& .MuiFormLabel-root": {
    minWidth: "70px",
  },
}));

export const StyledFormGroup = styled(FormGroup)({
  display: "flex",
  flexDirection: "row",
});

export const StyledFormcontrolLabel = styled(FormControlLabel)({
  "& .MuiFormControlLabel-label": {
    fontSize: "0.9rem",
  },
});
